import { useState } from "react";
import { BookOpen, CheckCircle2, PlayCircle, Bookmark } from "lucide-react";
import { toast } from "sonner";
import { http } from "@/lib/api";

const STATES = [["saved", "Saved", Bookmark], ["started", "Started", PlayCircle], ["finished", "Finished", CheckCircle2]];

export const LearningProgress = ({ favorites }) => {
  if (!favorites?.length) return null;
  const n = (s) => favorites.filter((f) => (f.status || "saved") === s).length;
  const fin = n("finished"), st = n("started"), total = favorites.length;
  return (
    <div className="rounded-2xl bg-white border border-[#1C242B]/10 p-6" data-testid="learning-progress-panel">
      <div className="flex items-center gap-2"><BookOpen size={16} className="text-[#3E6B5C]" /><p className="overline-label">Learning progress</p></div>
      <p className="font-display text-2xl font-bold mt-3" data-testid="learning-progress-summary">{`${fin} of ${total} finished`}</p>
      <div className="mt-3 h-2.5 rounded-full bg-slate-200/70 overflow-hidden flex">
        <div className="h-full bg-[#3E6B5C] transition-[width] duration-700" style={{ width: `${(fin / total) * 100}%` }} />
        <div className="h-full bg-[#F0A584] transition-[width] duration-700" style={{ width: `${(st / total) * 100}%` }} />
      </div>
      <div className="mt-3 flex flex-wrap gap-4 text-xs text-slate-600">
        <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#3E6B5C]" /> Finished: {fin}</span>
        <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#F0A584]" /> Started: {st}</span>
        <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-slate-300" /> Saved: {n("saved")}</span>
      </div>
      <ul className="mt-4 space-y-1.5 text-sm">
        {favorites.filter((f) => f.status && f.status !== "saved").map((f) => (
          <li key={f.career_id + f.url} className="flex gap-2"><span className={f.status === "finished" ? "text-[#3E6B5C]" : "text-[#C05630]"}>{f.status === "finished" ? "✓" : "▸"}</span>{f.label}</li>
        ))}
      </ul>
    </div>
  );
};

export const LearningChecklist = ({ token, favorites: initial }) => {
  const [favs, setFavs] = useState(initial);
  const setStatus = async (f, status) => {
    try {
      const { data } = await http.put(`/results/${token}/favorites/status`, { career_id: f.career_id, url: f.url, status });
      setFavs(data.favorites);
    } catch {
      toast.error("Could not update");
    }
  };
  return (
    <div>
      <LearningProgress favorites={favs} />
      <ul className="mt-5 grid gap-3" data-testid="learning-checklist">
        {favs.map((f, i) => (
          <li key={f.career_id + f.url} className="rounded-xl bg-white border border-[#1C242B]/10 p-4 flex flex-col sm:flex-row sm:items-center gap-3 justify-between" data-testid={`checklist-item-${i}`}>
            <a href={f.url} target="_blank" rel="noopener noreferrer" className="min-w-0 hover:text-[#D96B43] transition-colors">
              <span className="block font-medium">{f.label}</span>
              <span className="block text-xs text-slate-500 mt-0.5">{f.kind === "courses" ? "Course" : "Volunteering"} · {f.career_title}</span>
            </a>
            <div className="inline-flex shrink-0 rounded-full bg-[#FAF8F5] border border-[#1C242B]/12 p-1">
              {STATES.map(([k, l, I]) => (
                <button key={k} data-testid={`checklist-${i}-${k}-btn`} onClick={() => setStatus(f, k)}
                  className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs transition-colors ${(f.status || "saved") === k ? "bg-[#1C242B] text-white" : "text-slate-600 hover:text-[#1C242B]"}`}>
                  <I size={12} /> {l}
                </button>
              ))}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
